

import { Box, Button, useMediaQuery, useTheme } from "@mui/material";

import { useRef } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useEffect } from "react";


const slides = [
  {

    desktopImg: "/sliderimg/Your paragraph text.jpg",
    mobileImg: "/sliderimg/hero image mobile copy.jpg",
    icon: "/img1/Appstorebanner.png",
    icon1: "/img1/Playstorebanner.png"
  },

];



const handleAppStore = () => {
  window.open("https://apps.apple.com/in/app/yubai/id6751202148", "_blank");

  // GTM Tracking
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "app_store_click",
    button: "App Store Banner"
  });

  // Contentsquare (optional)
  if (window._uxa) {
    window._uxa.push(["trackAction", "app_store_banner_click"]);
  }
};

const handlePlayStore = () => {
  window.open("https://play.google.com/store/apps/details?id=com.yubai.app", "_blank");

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "play_store_click",
    button: "Play Store Banner"
  });

  if (window._uxa) {
    window._uxa.push(["trackAction", "play_store_banner_click"]);
  }
};





const BannerSlider = () => {

  const bannerRef = useRef(null);

  useEffect(() => {
    // Contentsquare
    if (window._uxa) {
      window._uxa.push(["trackAction", "banner_viewed"]);
    }

    // GTM
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "banner_viewed"
    });
  }, []);


  useEffect(() => {
    if (!bannerRef.current || !window._uxa) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Banner is visible → fire Contentsquare event
            window._uxa.push(["trackAction", "banner_in_view"]);
            // Optional: stop observing after first fire
            observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null, // viewport
        threshold: 0.5, // 50% of banner visible
      }
    );

    observer.observe(bannerRef.current);

    return () => observer.disconnect();
  }, []);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // ✅ detect xs
  return (
    <Box sx={{ width: "100%", overflow: "hidden", }}>

      <Box sx={{ mx: { xs: '0px', sm: "0px", md: "20px", } }}>

        {slides.map((slide, index) => (

          <Box ref={bannerRef} sx={{ position: "relative", width: "100%" }} key={index}>
            <Box
              component="img"
              src={isMobile ? slide.mobileImg : slide.desktopImg}
              alt={`Slide ${index + 1}`}
              sx={{
                width: "100%",
                height: { xs: "auto", sm: "auto", md: "auto" },
                objectFit: "cover",
                borderRadius: { xs: "0px", sm: "0px", md: "10px", lg: "10px" },
                mb: "10px",
              }}
            />



            {!isMobile ?

              <Box
                sx={{
                  position: "absolute",
                  bottom: { xs: "10px", sm: "60px", md: "150px", lg: "200px" },
                  display: "flex",
                  gap: 3,
                  ml: { md: "40px", lg: "48px" }
                }}
              >
                <Box component="img" src={slide.icon ? slide.icon : ""} sx={{ width: { md: "180px", lg: "200px" }, height: "auto", cursor: "pointer", }} onClick={handleAppStore} />
                <Box component="img" src={slide.icon1 ? slide.icon1 : ""} sx={{ width: { md: "180px", lg: "200px" }, height: "auto", cursor: "pointer", }} onClick={handlePlayStore} />



                {/* <Button
            sx={{
              bgcolor: "#374d91",
              color: "#f7ef6d",
              borderRadius: "50px",
              padding: "10px 20px",
              fontWeight: 600,
              fontSize: "14px",
              fontFamily: "Poppins",
            }}  
        OnClick={handleAppStore} 
          >
            Download IOS
          </Button>



          <Button
            sx={{
              bgcolor: "#374d91",
              color: "#f7ef6d",
              borderRadius: "50px",
              padding: "10px 20px",
              fontWeight: 600,
              fontSize: "14px",
              fontFamily: "Poppins",
            }}  
        OnClick={handlePlayStore} 
          >
            Download App
          </Button> */}

              </Box>


              :


              <Box
                sx={{
                  position: "absolute",
                  top: { xs: "38%", sm: "38%", },
                  left: { xs: "50%", sm: "50%" },
                  transform: "translateX(-50%)",
                  display: "flex",
                  gap: 2,
                  justifyContent: "center",
                }}
              >
                <Box
                  component="img"
                  src={slide.icon}
                  onClick={handleAppStore}
                  sx={{
                    width: { xs: 120, sm: 170, },
                    height: "auto",
                    cursor: "pointer",
                  }}
                />
                <Box
                  component="img"
                  src={slide.icon1}
                  onClick={handlePlayStore}
                  sx={{
                    width: { xs: 120, sm: 170, },
                    height: "auto",
                    cursor: "pointer",
                  }}
                />
              </Box>


            }

          </Box>

        ))}

      </Box>

    </Box>
  );
};

export default BannerSlider;
